import { Link } from 'react-router-dom';
import styles from './nameWithIdColumn.module.scss';
import classNames from 'classnames/bind';

export type NameWithIdColumnProps = {
  id: string | number;
  name: string;
  clickUrl?: string;
  showId: boolean;
  className?: string;
};

const cx = classNames.bind(styles);

export const NameWithIdColumn = ({
  id,
  name,
  clickUrl,
  className,
  showId = true
}: NameWithIdColumnProps) => {

  const nameClass = cx('name', {
    link: !!clickUrl
  });
  return (
    <div className={cx(className, styles.info)}>
      {
        clickUrl ?
          <Link to={clickUrl} className={nameClass}>
            {name}
          </Link> :
          <span className={nameClass}>{name}</span>
      }
      { showId && (
        <div className={styles.id}>
          {'ID: ' + id}
        </div>
      )}
    </div>
  );
};
